// extracted by mini-css-extract-plugin
export default {"base":"Stack_base__0tc4N"};